import { useCallback } from "react";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { AppFrame } from "../shell/AppFrame";
import { usePageTitle } from "../shell/title";
import { ProfilesView } from "../views/profiles/ProfilesView";
import { profilesSearchSchema, type ProfilesSearch } from "../views/profiles/search";
import { rootRoute } from "./root";

function ProfilesRoute({ personId, search }: { personId: string | null; search: ProfilesSearch }) {
  usePageTitle("Profiles");
  const navigate = useNavigate();
  const onSearch = useCallback(
    (next: ProfilesSearch) => {
      void navigate(
        personId
          ? { to: "/profiles/$profileId", params: { profileId: personId }, search: next }
          : { to: "/profiles", search: next },
      );
    },
    [navigate, personId],
  );
  return (
    <AppFrame view="Profiles">
      {() => (
        <ProfilesView
          personId={personId}
          search={search}
          onSearch={onSearch}
          onOpen={(id) => {
            void navigate(id ? { to: "/profiles/$profileId", params: { profileId: id } } : { to: "/profiles" });
          }}
        />
      )}
    </AppFrame>
  );
}

export const profilesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/profiles",
  validateSearch: profilesSearchSchema,
  component: function ProfilesListRoute() {
    return <ProfilesRoute personId={null} search={profilesRoute.useSearch()} />;
  },
});

export const profileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/profiles/$profileId",
  validateSearch: profilesSearchSchema,
  component: function ProfileRoute() {
    return <ProfilesRoute personId={profileRoute.useParams().profileId} search={profileRoute.useSearch()} />;
  },
});
